<!-- 节庆热点 -->
<template>
  <div class="category-management">
    <page-title title="筛选">
      <el-row class="category-management__filter-header" :gutter="20">
        <!-- <el-col :xl="4" :span="6">
          <span>套餐名称：</span>
          <el-input v-model="filter.type" placeholder="请输入"></el-input>
        </el-col> -->
        <el-col :xl="3" :span="6">
          <el-button @click="search" v-show="false">查询</el-button>
          <!-- <el-button @click="reset">重置</el-button> -->
          <el-button type="primary" @click="openDialog('add')"
            >新增套餐</el-button
          >
        </el-col>
      </el-row>
    </page-title>
    <page-title title="数据列表">
      <div class="category-management__body">
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          :header-cell-style="{ backgroundColor: `#f7f7f7` }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="100"
          ></el-table-column>
          <el-table-column prop="mealType" label="套餐类型" width="150">
            <template slot-scope="scope">
              <span>{{ mealType[scope.row.mealType] || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="授权类型"></el-table-column>
          <el-table-column
            prop="downloadTime"
            label="下载完成时间"
          ></el-table-column>
          <el-table-column prop="scope" label="授权范围"></el-table-column>
          <el-table-column prop="children" label="套餐产品">
            <template slot-scope="{ row }">
              <div>
                <span v-for="item in row.children" :key="item.id">
                  {{ item.count }}张￥{{ item.price }} ;</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                class="edit"
                type="text"
                @click="openDialog('detail', scope.row)"
                >详情</el-button
              >
              <el-button
                class="edit"
                type="text"
                @click="openDialog('edit', scope.row)"
                >编辑</el-button
              >
              <el-button class="edit" type="text" @click="deleteRow(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <cus-pagination
          :total="total"
          :current-page.sync="currentPage"
          :page-size.sync="pageSize"
          @size-change="getList"
        ></cus-pagination>
      </div>
    </page-title>
    <packageForm
      v-if="dialogVisible"
      :dialogMode="dialogMode"
      :currentData="currentData"
      @refresh="getList"
      :visible.sync="dialogVisible"
    ></packageForm>
  </div>
</template>

<script>
import { mealType } from "@/utils/enum";

import PageTitle from "@/components/pageTitle.vue";
import CusPagination from "@/components/cusPagination.vue";
import { getPackageList, delPackage } from "@/api/package";
import packageForm from "./components/packageForm.vue";
import { Message } from "element-ui";
export default {
  components: {
    PageTitle,
    CusPagination,
    packageForm,
  },
  data() {
    return {
      mealType,
      loading: true,
      filter: {
        type: "",
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogMode: "add", // 默认模式
      currentData: {}, // 当前表单数据
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
  },
  methods: {
    async getList() {
      this.loading = true;
      const { data } = await this.$ajax.get(getPackageList, {
        pageSize: this.pageSize,
        pageOn: this.currentPage,
        type: this.filter.type,
      });
      this.tableData = data?.data?.records || [];
      this.total = data?.data?.total || 0;
      this.loading = false;
    },
    search() {
      this.currentPage = 1;
      (this.pageSize = 10), this.getList();
    },
    reset() {
      this.filter.type = "";
      this.getList();
    },
    /**
     * 删除
     */
    deleteRow(row) {
      this.$confirm("确认删除该项吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleDelete(row.id);
        })
        .catch(() => {
          Message.info("删除已取消");
        });
    },
    handleDelete(id) {
      this.$ajax.delete(delPackage(id)).then((res) => {
        if (res.data.code === 200) {
          Message.success("删除成功");
          this.getList();
        }
      });
    },
    openDialog(mode, data = {}) {
      this.dialogMode = mode;
      this.currentData = { ...data };
      this.dialogVisible = true;
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.category-management {
  .box-card {
    margin-bottom: 20px;
  }

  &__filter-header {
    display: flex;
    align-items: center;
  }

  &__body {
    .edit {
      color: #005bff;
    }

    .el-button.is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
    }

    .el-switch__label {
      color: #333333;
    }

    .el-table {
      border: 1px solid #ebeef5;
      border-bottom: none;
      margin-bottom: 20px;
    }
  }
}
</style>
